import UpIcon from '@assets/svg/table-up.svg';
import DownIcon from '@assets/svg/table-down.svg';

import { useQuery } from 'react-query';
import { getDefaultFields } from '@services/queries/defaultFields/getDefaultFields/getDefaultFields';
import { TableContentLoading } from './DefaultFields.loading';

import {
  Container,
  Content,
  Header,
  Title,
  Line,
  Heading,
  Spacing,
  Divider,
  LineText,
  ColumnName,
  ColumnContainer,
  Direction,
  NoText,
  Wrapper,
} from './DefaultFields.styles';

interface IColumnTitle {
  label: string;
  direction?: 'up' | 'down' | null;
  onClick?: () => void;
}

const ColumnTitle = ({ label, direction, ...rest }: IColumnTitle) => {
  return (
    <ColumnContainer {...rest}>
      <ColumnName>{label}</ColumnName>
      {!!direction && (
        <Direction>
          <img src={direction === 'up' ? UpIcon : DownIcon} alt="direction" />
        </Direction>
      )}
    </ColumnContainer>
  );
};

const DefaultFields = () => {
  const { data } = useQuery(['defaultFields'], () => getDefaultFields());
  return (
    <Container>
      <Header>
        <Wrapper>
          <Title>
            Here you can see the default BeamON fields for your assets
          </Title>
        </Wrapper>
      </Header>

      <Spacing>
        <Heading>
          <ColumnTitle label="Name" onClick={() => {}} direction={null} />
          <ColumnTitle
            label="Description"
            onClick={() => {}}
            direction={null}
          />
          <ColumnTitle label="Type" onClick={() => {}} direction={null} />
          <ColumnTitle
            label="Default Value"
            onClick={() => {}}
            direction={null}
          />
          <ColumnTitle label="Onboard?" onClick={() => {}} direction={null} />
          <ColumnTitle label="Required" onClick={() => {}} direction={null} />
          <div />
        </Heading>
      </Spacing>

      <Divider />
      {data ? (
        <>
          <Content>
            {data.slice(0, 13).map(item => (
              <Spacing key={item.name}>
                <Line>
                  <LineText limitOfLines={1}>{item.name}</LineText>

                  {item.description ? (
                    <LineText limitOfLines={1}>{item.description}</LineText>
                  ) : (
                    <NoText>Empty</NoText>
                  )}

                  <LineText limitOfLines={1}>
                    {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
                  </LineText>

                  {item.defaultValue ? (
                    <LineText limitOfLines={1}>{item.defaultValue}</LineText>
                  ) : (
                    <NoText>No</NoText>
                  )}

                  {item.showOnOnboard ? (
                    <LineText limitOfLines={1}>Yes</LineText>
                  ) : (
                    <NoText>No</NoText>
                  )}

                  <LineText limitOfLines={1}>Yes</LineText>
                </Line>
              </Spacing>
            ))}
          </Content>
        </>
      ) : (
        <TableContentLoading />
      )}
    </Container>
  );
};

export { DefaultFields };
